import { AnnotationToolFeatureId, AnnotationToolSidebarAppID } from './annotationToolEnums';

export const ANNOTATION_TOOL_BASE_PATH = AnnotationToolSidebarAppID.annotationTool;

export const ANNOTATION_TOOL_DASHBOARD_PATH = AnnotationToolFeatureId.annotationDashboard;
export const ANNOTATION_TOOL_SUPERVISOR_PATH = AnnotationToolFeatureId.annotationSupervisor;
export const ANNOTATION_TOOL_ANNOTATION_PATH = AnnotationToolFeatureId.annotation;
export const ANNOTATION_TOOL_ANNOTATOR_PROJECTS_PATH = AnnotationToolFeatureId.annotatorProjects;
export const ANNOTATION_TOOL_SUPERVISOR_PROJECTS_PATH = AnnotationToolFeatureId.supervisorProjects;
export const ANNOTATION_TOOL_ADMIN_PROJECTS_PATH = AnnotationToolFeatureId.adminProjects;
export const ANNOTATION_TOOL_METRICS_PATH = AnnotationToolFeatureId.metrics;
export const ANNOTATION_TOOL_METRICS_DASHBOARD_PATH = `${AnnotationToolFeatureId.metrics}/${AnnotationToolFeatureId.metricsDashboard}`;
export const ANNOTATION_TOOL_METRICS_SUMMARY_PATH = `${AnnotationToolFeatureId.metrics}/${AnnotationToolFeatureId.metricsSummary}`;
export const ANNOTATION_TOOL_METRICS_ENCOUNTER_STATS_PATH = `${AnnotationToolFeatureId.metrics}/${AnnotationToolFeatureId.metricsEncounterStats}`;
export const ANNOTATION_TOOL_METRICS_IRR_SCORE_PATH = `${AnnotationToolFeatureId.metrics}/${AnnotationToolFeatureId.metricsIRRScore}`;
export const ANNOTATION_TOOL_METRICS_HOLIDAYS_PATH = `${AnnotationToolFeatureId.metrics}/${AnnotationToolFeatureId.metricsHolidays}`;

export const getAnnotationToolBasePath = () => {
  return `/${ANNOTATION_TOOL_BASE_PATH}`;
};

export const getAnnotationToolDashboardPath = () => {
  return `${getAnnotationToolBasePath()}/${ANNOTATION_TOOL_DASHBOARD_PATH}`;
};

export const getAnnotationToolSupervisorPath = () => {
  return `${getAnnotationToolBasePath()}/${ANNOTATION_TOOL_SUPERVISOR_PATH}`;
};

export const getAnnotationToolAnnotatorQueuePath = () => {
  return `${getAnnotationToolBasePath()}/${ANNOTATION_TOOL_ANNOTATION_PATH}`;
};

export const getAnnotationToolAnnotatorProjectPath = () => {
  return `${getAnnotationToolBasePath()}/${ANNOTATION_TOOL_ANNOTATOR_PROJECTS_PATH}`;
};

export const getAnnotationToolSupervisorProjectPath = () => {
  return `${getAnnotationToolBasePath()}/${ANNOTATION_TOOL_SUPERVISOR_PROJECTS_PATH}`;
};

export const getAnnotationToolAdminProjectsPath = () => {
  return `${getAnnotationToolBasePath()}/${ANNOTATION_TOOL_ADMIN_PROJECTS_PATH}`;
};

export const getAnnotationToolMetricsPath = () => {
  return `${getAnnotationToolBasePath()}/${ANNOTATION_TOOL_METRICS_PATH}`;
};

export const getAnnotationToolMetricsDashboardPath = () => {
  return `${getAnnotationToolBasePath()}/${ANNOTATION_TOOL_METRICS_DASHBOARD_PATH}`;
};

export const getAnnotationToolMetricsSummaryPath = () => {
  return `${getAnnotationToolBasePath()}/${ANNOTATION_TOOL_METRICS_SUMMARY_PATH}`;
};

export const getAnnotationToolMetricsEncounterStatsPath = () => {
  return `${getAnnotationToolBasePath()}/${ANNOTATION_TOOL_METRICS_ENCOUNTER_STATS_PATH}`;
};

export const getAnnotationToolMetricsIRRScorePath = () => {
  return `${getAnnotationToolBasePath()}/${ANNOTATION_TOOL_METRICS_IRR_SCORE_PATH}`;
};

export const getAnnotationToolMetricsHolidaysPath = () => {
  return `${getAnnotationToolBasePath()}/${ANNOTATION_TOOL_METRICS_HOLIDAYS_PATH}`;
};

export const getAnnotationToolSupervisorProjectDetailsPath = (projectId: string) => {
  return `${getAnnotationToolBasePath()}/${ANNOTATION_TOOL_SUPERVISOR_PROJECTS_PATH}/project-details/${projectId}`;
};

export const getAnnotationToolSupervisorProjectMetricsPath = (
  projectId: string,
  metricsView: string
) => {
  return `${getAnnotationToolSupervisorProjectDetailsPath(projectId)}/metrics/${metricsView}`;
};

export const ANNOTATION_TOOL_ADMIN_SUPERVISOR_REVIEW_PATH = 'admin-supervisor-review';

export const getAnnotationToolAdminSupervisorReviewPath = () => {
  return `${getAnnotationToolBasePath()}/${ANNOTATION_TOOL_ADMIN_SUPERVISOR_REVIEW_PATH}`;
};

export const ANNOTATION_TOOL_GENERATE_ACCURACY_PATH = 'generate-accuracy';

export const getAnnotationToolGenerateAccuracyPath = (projectId: string) => {
  return `${getAnnotationToolAdminProjectsPath()}/${ANNOTATION_TOOL_GENERATE_ACCURACY_PATH}/${projectId}`;
};
